import { render, staticRenderFns } from "./DocumentationButton.vue?vue&type=template&id=24d7b28c&scoped=true&"
import script from "./DocumentationButton.vue?vue&type=script&lang=js&"
export * from "./DocumentationButton.vue?vue&type=script&lang=js&"
import style0 from "./DocumentationButton.vue?vue&type=style&index=0&id=24d7b28c&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d7b28c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/unitech/keymetrics/pm2-io/keymetrics/pm2-io-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24d7b28c')) {
      api.createRecord('24d7b28c', component.options)
    } else {
      api.reload('24d7b28c', component.options)
    }
    module.hot.accept("./DocumentationButton.vue?vue&type=template&id=24d7b28c&scoped=true&", function () {
      api.rerender('24d7b28c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DocumentationButton.vue"
export default component.exports